import _ from 'lodash';

/**
 * @name ConfirmAppointmentController
 * @description Controller for confirming appointments
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {service} Appointment The appointment service
 * @param {object} appointment The appointment resolve
 * @param {object} project The project resolve
 * @param {object} shopMessageTemplates The shopMessageTemplates resolve
 * @param {constant} NOTIFICATIONS The notifications constant
 * @param {service} Session The Session service
 * @param {service} Notification The notification service
 * @param {service} AlertMessages The alert messages constant
 * @param {service} Messages The Messages service
 * @param {angular} $q The Angular $q service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 */
function ConfirmAppointmentController(
  $uibModalInstance,
  Appointment,
  appointment,
  project,
  shopMessageTemplates,
  NOTIFICATIONS,
  Session,
  Notification,
  AlertMessages,
  Messages,
  $q,
  collectorWantsNotif
) {
  let vm = this;

  vm.shopMessageTemplates = shopMessageTemplates;
  vm.appointment = _.cloneDeep(appointment);
  vm.project = _.cloneDeep(project);
  vm.session = Session;
  vm.confirmAppointment = confirmAppointment;
  vm.message = {
    cid: vm.appointment.conversations,
    content: null,
    private: false
  };

  /**
   * @name confirmAppointment
   * @description Function to confirm an appointment
   */
  function confirmAppointment() {
    let promises = $q.all({});

    let status = 50;
    let appointmentData = {
      id: vm.appointment.id
    };
    if (vm.appointment.previously_paid === false) {
      appointmentData.estimate_min = vm.appointment.estimate_min;
      appointmentData.estimate_max = vm.appointment.estimate_max;
    } else {
      appointmentData.previously_paid = true;
    }

    appointmentData.deposit_amount = vm.appointment.deposit_amount ?
    vm.appointment.deposit_amount : null;

    promises.appointment = Appointment.update(appointmentData, status)
    .then(function(appointment) {
      // Send an email notification to collectors
      let notificationCollector = {
        recipients: [vm.project.collector.id],
        notificationId: NOTIFICATIONS.appointmentConfirmedByOperatorOrArtist,
        messageObjects: {
          appointmentId: appointment.id,
          projectId: vm.project.id,
          // The collector who owns the project
          collectorId: vm.project.collector.id,
          // The logged in operator or artist
          operatorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name +
          ', ' + Session.collector.first_name + ' ' +
          Session.collector.last_name +
          ' confirmed an appointment for your project on Ink Finder',
          tattooProcess: vm.shopMessageTemplates &&
          vm.shopMessageTemplates.tattoo_process !== '' ?
          vm.shopMessageTemplates.tattoo_process : ''
        }
      };
      if (Session.activeState.association.shop.id) {
        notificationCollector.messageObjects.shopId =
        Session.activeState.association.shop.id;
        notificationCollector.messageVariables.subject =
        vm.project.collector.first_name +
        ', ' + Session.collector.first_name + ' ' +
        Session.collector.last_name + ' at ' +
        Session.activeState.association.shop.name +
        ' confirmed an appointment for your project on Ink Finder';
      }

      // Send an email notification to artists
      let notificationArtist = {
        recipients: [appointment.artist.id],
        notificationId: NOTIFICATIONS.artistConfirmed,
        messageObjects: {
          appointmentId: appointment.id,
          projectId: vm.project.id,
          // The collector who owns the project
          collectorId: vm.project.collector.id,
          // The logged in operator or artist
          operatorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: appointment.artist.id
        },
        messageVariables: {
          subject: appointment.artist.first_name +
          ', ' + Session.collector.first_name + ' ' +
          Session.collector.last_name + ' at ' +
          Session.activeState.association.shop.name +
          ' confirmed your appointment with ' +
          vm.project.collector.first_name + ' ' +
          vm.project.collector.last_name + ' on Ink Finder'
        }
      };
      if (Session.activeState.association.shop.id) {
        notificationArtist.messageObjects.shopId =
        Session.activeState.association.shop.id;
      }
      Notification.send(notificationCollector);
      // Only send artist notifications if the artist isn't the one creating
      // the appointment and they want to receive the email
      collectorWantsNotif
      .check(appointment.artist.id, appointment.shop,
      'appointment_confirmed', 'artist')
      .then(function(collectorWantsNotif) {
        if (Session.collector.id !== appointment.artist.id &&
        collectorWantsNotif) {
          Notification.send(notificationArtist);
        }
      });
      return appointment;
    });

    // Save a message on the appointment if one exists
    if (vm.message.content !== null &&
    vm.message.content.replace(/\s/g, '').length) {
      promises.message = Messages.create(vm.message)
      .then(function(message) {
        return message;
      });
    }

    // Process all promises
    $q.all(promises).then(function(results) {
      $uibModalInstance.close(results.appointment);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'warning'});
    });
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('ConfirmAppointmentController', ConfirmAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/confirm/confirm.controller.js